import React from "react"

import { Alert, AlertDescription } from "@/components/ui/alert"
import { cn } from "@/lib/utils"

import {
  BROKER_ALERT_CLASS,
  BROKER_ALERT_DESC_CLASS,
  BrokerAlertIcon,
} from "./brokerAlertUi"
import BrokerGuidancePanel from "./BrokerGuidancePanel"
import {
  ChecklistRow,
  GuidanceAccordionBody,
  GuidanceBlock,
  GuidanceIntro,
} from "./ibkrGuidanceShared"

const BinanceCsvImportGuidance: React.FC = () => {
  return (
    <BrokerGuidancePanel title="How to export Binance Spot Trade History" collapsible>
      <GuidanceAccordionBody>
        <GuidanceIntro className="!mb-0">
          Upload the <strong>Spot Trade History</strong> CSV from Binance, not Wallet → Transaction
          History.
        </GuidanceIntro>

        <GuidanceBlock title="Export steps">
          <ChecklistRow className="!mb-0">
            Binance website → <strong>Orders</strong> → <strong>Spot Order</strong>
          </ChecklistRow>
          <ChecklistRow className="!mb-0">
            Open the <strong>Trade History</strong> tab
          </ChecklistRow>
          <ChecklistRow className="!mb-0">
            Set your date range and click <strong>Export</strong>
          </ChecklistRow>
          <ChecklistRow className="!mb-0">Upload the downloaded CSV here</ChecklistRow>
        </GuidanceBlock>

        <GuidanceBlock title="Required columns">
          <ChecklistRow className="!mb-0">
            Date(UTC), Pair, Side, Price, Executed, Amount, Fee
          </ChecklistRow>
          <p className={cn(BROKER_ALERT_DESC_CLASS, "!mb-0")}>
            Binance limits each export to about three months. Export multiple files for longer
            history.
          </p>
        </GuidanceBlock>
      </GuidanceAccordionBody>
    </BrokerGuidancePanel>
  )
}

export const BinanceCsvTransactionHistoryWarning: React.FC = () => {
  return (
    <Alert variant="warning" className={BROKER_ALERT_CLASS}>
      <BrokerAlertIcon tone="warning" />
      <AlertDescription className={cn(BROKER_ALERT_DESC_CLASS, "col-start-2")}>
        <p>
          Do not use Transaction History (
          <strong>User ID, Operation, Coin, Change</strong>
          ). Tessera cannot import trades from that ledger file.
        </p>
      </AlertDescription>
    </Alert>
  )
}

export default BinanceCsvImportGuidance
